
import { gql } from "@apollo/client";

export const TIP_WITH_PLANY_COINS = gql`
  mutation TipWithCoins($input: TipInput!) {
    tipWithPlanyCoins(input: $input)
  }
`;
 
export const BUY_COINS_MUTATION = gql`
  mutation BuyPlanyCoins($input: BuyCoinsInput!) {
    buyPlanyCoins(input: $input) {
      success
      transactionId
      message
    }
  }
`;

export const WITHDRAW_COINS_MUTATION = gql`
  mutation WithdrawPlanyCoins($input: WithdrawInput!) {
    withdrawPlanyCoins(input: $input) {
      success
      message
      withdrawnCoins
    }
  }
`;